module.exports = new __parcel__URL__("Eliot.b55e69ea.svg").toString();